import { render, staticRenderFns } from "./UniversalQrModal.vue?vue&type=template&id=5a8d6854&scoped=true"
import script from "./UniversalQrModal.vue?vue&type=script&lang=js"
export * from "./UniversalQrModal.vue?vue&type=script&lang=js"
import style0 from "./UniversalQrModal.vue?vue&type=style&index=0&id=5a8d6854&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a8d6854",
  null
  
)

export default component.exports